import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["active", "children", "data-testid", "hasItems", "hoveredItem", "isOpen", "navItem"];
import React from 'react';
import { styled } from '@mui/material/styles';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import Typography from '@mui/material/Typography';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { renderSideNavItemIcon } from './renderSideNavItemIcon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function SideNavButton(props) {
  var active = props.active,
    children = props.children,
    _props$dataTestid = props['data-testid'],
    testid = _props$dataTestid === void 0 ? 'required' : _props$dataTestid,
    hasItems = props.hasItems,
    hoveredItem = props.hoveredItem,
    isOpen = props.isOpen,
    navItem = props.navItem,
    others = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_jsxs(StyledListItemButton, _extends({
    "aria-expanded": isOpen ? 'true' : undefined,
    "aria-haspopup": "true",
    "aria-label": typeof children === 'string' ? children : 'menu-item',
    className: active ? 'active' : undefined,
    "data-testid": testid,
    disableRipple: true,
    isHover: true,
    isVisible: true
  }, others, {
    "data-element": "StyledListItemButton",
    "data-component": "SideNavButton",
    "data-source-file": "SideNavButton.tsx",
    children: [/*#__PURE__*/_jsx(StyledListItemIcon, {
      "data-element": "StyledListItemIcon",
      "data-source-file": "SideNavButton.tsx",
      children: renderSideNavItemIcon(navItem.key, active, (hoveredItem == null ? void 0 : hoveredItem.key) === navItem.key)
    }), /*#__PURE__*/_jsx(StyledTypography, {
      isHover: active,
      isVisible: true,
      "data-element": "StyledTypography",
      "data-source-file": "SideNavButton.tsx",
      children: children
    }), hasItems && /*#__PURE__*/_jsx(StyledArrowIcon, {
      isHover: active,
      isVisible: true,
      children: /*#__PURE__*/_jsx(ArrowForwardIosIcon, {
        sx: {
          height: '12px',
          minWidth: 'inherit',
          width: '12px'
        }
      })
    })]
  }));
}
var StyledListItemIcon = styled(ListItemIcon)(function (_ref) {
  var theme = _ref.theme;
  return {
    color: theme.palette.grey[600],
    minWidth: 24
  };
});
var StyledListItemButton = styled(ListItemButton, {
  shouldForwardProp: function shouldForwardProp(props) {
    return props !== 'isHover' && props !== 'isVisible';
  }
})(function (_ref2) {
  var isVisible = _ref2.isVisible,
    theme = _ref2.theme;
  return {
    '&.active': {
      '& .MuiTypography-root': {
        color: theme.palette.primary[900]
      },
      '&:hover': {
        '& .MuiTypography-root': {
          color: theme.palette.primary[900]
        }
      },
      backgroundColor: theme.palette.primary[50]
    },
    '&:first-of-type': {
      marginTop: 0
    },
    '&:hover': {
      '& .MuiTypography-root': {
        color: theme.palette.primary[900]
      }
    },
    '&:not(&:first-of-type)': {
      marginTop: 8
    },
    alignItems: 'center',
    borderRadius: 4,
    display: 'flex',
    flexDirection: 'row',
    fontSize: '14px',
    justifyContent: 'left',
    maxHeight: 48,
    overflow: 'hidden',
    padding: '12px',
    textAlign: 'center',
    width: '100%'
  };
});
var StyledTypography = styled(Typography, {
  shouldForwardProp: function shouldForwardProp(props) {
    return props !== 'isHover' && props !== 'isVisible';
  }
})(function (_ref3) {
  var isHover = _ref3.isHover,
    isVisible = _ref3.isVisible,
    theme = _ref3.theme;
  return {
    color: isHover ? theme.palette.primary.main : theme.palette.grey[600],
    display: isVisible ? 'block' : 'none',
    fontSize: '14px',
    margin: '0 8px',
    textAlign: 'left',
    width: '100%'
  };
});
var StyledArrowIcon = styled(ListItemIcon, {
  shouldForwardProp: function shouldForwardProp(props) {
    return props !== 'isVisible' && props !== 'isHover';
  }
})(function (_ref4) {
  var isVisible = _ref4.isVisible,
    theme = _ref4.theme;
  return {
    display: isVisible ? 'block' : 'none',
    minWidth: 'inherit'
  };
});